import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
/**
 * Resolves the `track` prop and returns a handler that fires the action
 * before delegating. Pass stable `defaultOptions` (module-level or memoed)
 * to keep the returned callback stable across renders.
 */
export function useTrackOnClick(track, defaultOptions, handler) {
    const { track: trackEvent } = useInstrumentation();
    return useCallback((event) => {
        if (track !== false) {
            trackEvent(track ?? defaultOptions);
        }
        handler?.(event);
    }, [track, defaultOptions, handler, trackEvent]);
}
//# sourceMappingURL=useTrackOnClick.js.map